import React, {Component} from "react";

const Banner = ()=>{
    return (
    <div></div>
        // <div className="row">
        //     <div
        //         className="col"
        //         style={{
        //             padding: 10,
        //             backgroundColor: "rgb(0, 88, 161)",
        //             color: "white",
        //             marginLeft: 15,
        //             marginBottom: 1
        //         }}
        //     >
        //         {/* <p><b>Notice Banner Header goes here.</b></p>
        //         <p>
        //             // Notice Banner message goes here.
        //         </p> 
        //         */}
        //     </div>
        // </div>
);

}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.jsx